import { actionConstants } from './actionConstants';
import noti from './toast';
import { get } from './method';

export default {
  getGroups,
  getDepartments,
  getDepartmentsWithoutGlobal,
  getRoles,
  getGroupsForScheduledReports,
  getBRGroupsByDeptId,
  getUsers,
  getTimezones,
};

function getGroups() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/groups?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_GROUPS_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_GROUPS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getDepartments() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/departments?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_DEPARTMENTS_SUCCESS,
          data: resp,
        });
        return resp.items;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_DEPARTMENTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getDepartmentsWithoutGlobal() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(
      `app/lookup/departments/without-global-department?MaxResultCount=1000`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_DEPARTMENTS_SUCCESS,
          data: resp,
        });
        return resp.items;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_DEPARTMENTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getRoles() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/roles?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_ROLES_SUCCESS,
          data: resp,
        });
        return resp.items;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_ROLES_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getGroupsForScheduledReports() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/scheduled-reports/groups?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_SUCCESS,
          data: resp,
        });
        return resp.items;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getBRGroupsByDeptId(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(
      `app/lookup/batch-reports/groups/${deptId}?MaxResultCount=1000`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_BR_GROUPS_BY_DEPT_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_BR_GROUPS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getUsers() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/users?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_USERS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_USERS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getTimezones() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/lookup/timezones`)
      .then((resp) => {
        dispatch({
          type: actionConstants.LOOKUP_TIMEZONES_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.LOOKUP_TIMEZONES_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
